import React, { ComponentProps, FC } from 'react';
import { PlcImg } from '@components/PlcImg/PlcImg.component';
import { Text } from '@components/Text/Text.component';
import { ImageSrc } from '@utils/images';
import classnames from 'classnames';
import styles from './LandingPageAppCard.module.scss';

interface CardProps extends ComponentProps<'section'> {
  cardImage?: ImageSrc;
  cardTitle?: string;
  cardContent?: React.ReactNode;
  cardMention?: string;
}

const LandingPageAppCard: FC<CardProps> = ({ cardImage, cardTitle, cardContent, cardMention, className }) => {
  const rootClass = classnames(styles['content-card'], 'flex', 'column', className);
  const cardImageClass = classnames(styles['card-image']);
  return (
    <section className={rootClass}>
      <header>
        {cardImage && <PlcImg alt="" className={cardImageClass} plcSrc={{ src: cardImage, type: 'local' }} />}
      </header>
      <div className="flex column flex-1 plc-pt-s">
        {cardTitle && <Text className={styles['card-title']} i18nKey={cardTitle} variant="h4" />}
        {cardContent && <div>{cardContent}</div>}
        {cardMention && (
          <Text className="plc-my-s" i18nKey={cardMention} style={{ fontStyle: 'italic' }} variant="tiny" />
        )}
      </div>
    </section>
  );
};

export { LandingPageAppCard };
